(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompendiumReportGroupDialogController', CompendiumReportGroupDialogController);

    CompendiumReportGroupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompendiumReportGroup'];

    function CompendiumReportGroupDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CompendiumReportGroup) {
        var vm = this;

        vm.compendiumReportGroup = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.compendiumReportGroup.id !== null) {
                CompendiumReportGroup.update(vm.compendiumReportGroup, onSaveSuccess, onSaveError);
            } else {
                CompendiumReportGroup.save(vm.compendiumReportGroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:compendiumReportGroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
